import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";
import useScrollLock from "@repo/shopify/hooks/useScrollLock";
import type { Menu } from "@shopify/hydrogen-react/storefront-api-types";
import classNames from "classnames";
import React from "react";

import Link from "@atoms/Link";

import useCheckLocation from "@hooks/useCheckLocation";
import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

interface IProps {
  menu: Menu | undefined;
}

export default function HeaderNavigation({ menu }: IProps) {
  const { domain, shopifyDomain } = useLanguage();

  const { openNavigation } = useLayoutStore();

  const { isDanielJohnston } = useCheckLocation();

  const { isPC } = useCheckDevice();

  useScrollLock();

  return (
    <>
      {isPC ? (
        <div
          className={classNames(
            "fixed top-12 left-0 h-dvh w-dvw bg-white",
            isDanielJohnston ? "dark:bg-dj-black" : "dark:bg-black",
          )}
        />
      ) : null}
      <div
        className={classNames(
          "scrollbar-hide pc:absolute pc:top-full pc:h-[calc(100vh-3.75rem)] pc:w-auto pc:px-0 pc:pt-0 pc:-left-4 fixed top-0 left-0 z-30 h-dvh w-full overflow-y-scroll bg-white px-4 pt-12.5 dark:text-white",
          isDanielJohnston ? "dark:bg-dj-black" : "dark:bg-black",
        )}
      >
        <div
          className="tnt-gap-x pc:w-screen-col-span-2 pc:grid-cols-2 pc:pb-5 pc:gap-y-2.5 pc:pl-4 grid h-fit auto-rows-min grid-cols-8 gap-y-3.5 pt-4 pb-4"
          onMouseEnter={() => {
            openNavigation(true);
          }}
          onMouseLeave={() => {
            openNavigation(false);
          }}
        >
          {menu?.items.map((item) => (
            <React.Fragment key={item.id}>
              {item.title !== "Archives" && (
                <div className="tnt-gap-x pc:col-start-1 col-span-8 col-start-2 flex">
                  <Link
                    as="text"
                    className={classNames(
                      "pc:col-span-1 col-span-5 w-fit leading-none",
                      item.title === "Archives" && "pc:pt-2.5 pt-3.5",
                      !isPC && "text-base!",
                    )}
                    href={item.url?.replace(domain, "").replace(shopifyDomain, "")}
                    onClick={() => {
                      openNavigation(false);
                    }}
                  >
                    {`${item.title}${item.title === "Archives" ? ":" : ""}`}
                  </Link>
                </div>
              )}

              {isPC ? (
                <>
                  {item.title === "Archives" && (
                    <>
                      <Link
                        as="text"
                        className="col-span-1 w-fit pt-2 leading-none"
                        href={item.url?.replace(domain, "").replace(shopifyDomain, "")}
                        onClick={() => {
                          openNavigation(false);
                        }}
                      >
                        Archives:
                      </Link>

                      {item.items.length ? (
                        <div className="col-span-2 col-start-1 flex w-fit flex-col gap-2.5">
                          <div className="ml-5 flex flex-col gap-2 dark:border-white">
                            {item.items.map((subItem) => (
                              <Link
                                as="text"
                                className={classNames("w-fit leading-none", !isPC && "text-base!")}
                                href={subItem.url?.replace(domain, "").replace(shopifyDomain, "")}
                                key={subItem.id}
                                onClick={() => {
                                  openNavigation(false);
                                }}
                              >
                                {subItem.title}
                              </Link>
                            ))}
                          </div>
                        </div>
                      ) : null}
                    </>
                  )}
                </>
              ) : (
                <>
                  {item.title === "Archives" && (
                    <div className="col-start-2 flex gap-2 pt-2">
                      <Link
                        as="text"
                        className="col-span-1 w-fit text-base! leading-none"
                        href={item.url?.replace(domain, "").replace(shopifyDomain, "")}
                        onClick={() => {
                          openNavigation(false);
                        }}
                      >
                        Archives:
                      </Link>

                      {item.items.length ? (
                        <div className="col-span-5 col-start-2 flex w-fit flex-col gap-2.5">
                          <div className="flex flex-col gap-3.5 dark:border-white">
                            {item.items.map((subItem) => (
                              <Link
                                as="text"
                                className={classNames("w-fit leading-none", !isPC && "text-base!")}
                                href={subItem.url?.replace(domain, "").replace(shopifyDomain, "")}
                                key={subItem.id}
                                onClick={() => {
                                  openNavigation(false);
                                }}
                              >
                                {subItem.title}
                              </Link>
                            ))}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}
                </>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
}
